import sanityClient from "@sanity/client"

export default sanityClient({
    "projectId": "j1zm8pj9",
    "dataset": "production",
    "useCdn": true
})
